import type { QueryKey } from '@tanstack/react-query'

import { assistantEffects } from '@/lib/assistant-effects.generated'

export const userKeys = {
  root: ['users'] as const,
  list: (entityId: string, query = '', includeDeactivated = false) => ['users', 'list', entityId, query, includeDeactivated] as const,
  machineList: (entityId: string, query = '') =>
    ['users', 'machine-list', entityId, query] as const,
  machineDetail: (entityId: string, userId: string) =>
    ['users', 'machine-detail', entityId, userId] as const,
  candidates: (entityId: string, query = '') => ['users', 'candidates', entityId, query] as const,
  accessProfile: (entityId: string, userId: string, serviceAccount = false) =>
    ['users', 'access-profile', entityId, userId, serviceAccount] as const,
  pending: (entityId: string) => ['users', 'pending', entityId] as const,
}

export const oauthApplicationKeys = {
  root: ['oauth-applications'] as const,
  scopes: ['oauth-applications', 'scopes'] as const,
  templates: ['oauth-applications', 'templates'] as const,
  list: (entityId: string) => ['oauth-applications', 'list', entityId] as const,
  detail: (entityId: string, applicationId: string) =>
    ['oauth-applications', 'detail', entityId, applicationId] as const,
}

export const roleKeys = {
  root: ['roles'] as const,
  list: (entityId: string) => ['roles', 'list', entityId] as const,
  detail: (entityId: string, roleId: string) =>
    ['roles', 'detail', entityId, roleId] as const,
  assignable: (entityId: string) => ['roles', 'assignable', entityId] as const,
}

export const groupKeys = {
  root: ['groups'] as const,
  list: (entityId: string) => ['groups', 'list', entityId] as const,
  detail: (entityId: string, groupId: string) =>
    ['groups', 'detail', entityId, groupId] as const,
  members: (entityId: string, groupId: string) =>
    ['groups', 'members', entityId, groupId] as const,
  memberCandidates: (entityId: string, groupId: string, query = '') =>
    ['groups', 'member-candidates', entityId, groupId, query] as const,
}

export const accessSummaryKeys = {
  root: ['access-summary'] as const,
  summary: (entityId: string) => ['access-summary', entityId] as const,
}

export const assistantEffectMeta = {
  assistantEffects: [assistantEffects.identityChanged],
} as const

export function iamInvalidates(): QueryKey[] {
  return [userKeys.root, groupKeys.root, roleKeys.root, accessSummaryKeys.root]
}
